export default __webpack_public_path__ + "static/media/undraw_empty.86aaba3d.svg";